
import { Container, Box, Typography, TextField, FormControl } from '@mui/material';
import { ReEvent } from '../../interfaces/types';


// Define the props for the EventTextInputSection component
interface TextInputSectionProps {
  event: ReEvent;
  setEvent: (event: ReEvent) => void;
  label: string;
  subfield?: boolean;
  fieldName: keyof ReEvent | keyof ReEvent["eventConfiguration"];
  required?: boolean;
}

// Define the EventTextInputSection functional component
const EventTextInputSection: React.FC<TextInputSectionProps> = ({
  event,
  setEvent,
  label,
  fieldName,
  subfield = false,
  required = false,
}) => {
  return (
    <Container
      disableGutters
      sx={{
        justifyContent: "flex-start",
        display: "flex",
        alignItems: "center",
        mt: 2,
      }}
    >
      <Box display="flex" flex={"35%"} justifyContent={"flex-start"}>
        {/* Display the label */}
        <Typography>{label + ":"}</Typography>
      </Box>
      <Box display="flex" flex={"65%"} justifyContent={"center"}>

        {/* Render the TextField component */}
          <TextField
            label={label}
            value={subfield ? event.eventConfiguration[fieldName as keyof ReEvent["eventConfiguration"]] as string : event[fieldName as keyof ReEvent] as string}
            onChange={(e) => subfield ? setEvent({ ...event, eventConfiguration: { ...event.eventConfiguration, [fieldName]: e.target.value } }) : setEvent({ ...event, [fieldName]: e.target.value })}
            fullWidth
            required={required}
            margin="normal"
          />

        
       
      </Box>
    </Container>
  );
};

export default EventTextInputSection;
